import React, { useState } from "react";
import { FiLock, FiMail } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../store/slices/authSlice";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { setAdminRole, setUserRole } from "../../store/slices/userSlice";
import "react-toastify/dist/ReactToastify.css";
import jwt_decode from "jwt-decode";
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const handleLoginEvent = async (e) => {
    e.preventDefault();
    const credentials = {
      email,
      password,
    };
    dispatch(loginUser(credentials))
      .unwrap()
      .then((response) => {
        if (response.success === false) {
          toast.error("Emaili ose fjalëkalimi janë gabim!");
        } else {
          const decoded = jwt_decode(response.token);
          localStorage.setItem("userToken", response.token);
          localStorage.setItem("isAuthenticated", true);
          if (decoded.role === "admin") {
            navigate("/dashboard");
          } else {
            navigate("/movment");
          }
          toast.success("Jeni kyçur me sukses!");
        }
      });
  };

  return (
    <div className="relative flex flex-col justify-center min-h-screen overflow-hidden bg-main-bg px-4">
      <div className="pt-10 pb-6 text-center">
        <p className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-800">
          Autoshkollaime
        </p>
      </div>

      <div className="w-full max-w-md mx-auto p-6 sm:p-8 bg-white rounded-xl shadow-md">
        <h1 className="text-lg sm:text-xl font-semibold text-[#FCB425] text-center">
          Mirësevini në Autoshkollaime
        </h1>

        <form className="mt-6 space-y-4" onSubmit={handleLoginEvent}>
          <div>
            <label className="relative text-gray-400 focus-within:text-gray-600 block">
              <FiMail className="pointer-events-none w-5 h-5 absolute top-1/2 transform -translate-y-1/2 left-3" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                required
                className="pl-12 pr-4 py-3 w-full rounded-md border text-sm bg-white text-gray-700 placeholder-gray-400 focus:outline-none focus:border-black"
              />
            </label>
          </div>

          <div>
            <label className="relative text-gray-400 focus-within:text-gray-600 block">
              <FiLock className="pointer-events-none w-5 h-5 absolute top-1/2 transform -translate-y-1/2 left-3" />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Passwordi"
                required
                className="pl-12 pr-4 py-3 w-full rounded-md border text-sm bg-white text-gray-700 placeholder-gray-400 focus:outline-none focus:border-black"
              />
            </label>
          </div>

          <div className="pt-4 flex justify-center">
            <button
              type="submit"
              className="w-full sm:w-[50%] px-4 py-3 tracking-wide text-white text-sm bg-theme-color rounded-md hover:bg-hover-color transition duration-200 focus:outline-none focus:bg-hover-color"
              disabled={loading}
            >
              {loading ? "Duke procesuar..." : "Kyçu"}
            </button>
          </div>
        </form>
      </div>

      <ToastContainer />
    </div>
  );
};

export default Login;
